export default {
    en: {
        homepage: 'Homepage',
        personalInfo: 'Information',
        modifyPersonalInfo: 'Change',
        researchMenu: {
            name: 'Research Achievement',

            menu: {
                article: 'Article',
                book: 'Book',
                exhibit: 'Exhibition & Recital',
                academic: 'Academic Activity',
            }
        },
        educationMenu: {
            name: 'Teaching Achievement',

            menu:{
                teaching: 'Teaching',
            }
        },
        volunteerMenu: {
            name : 'Service Achievement',

            menu: {
                service: 'Service',
            }
        },
        awardMenu: {
            name: 'Award Achievement',

            menu: {
                award: 'Award'
            }
        },
        reportMenu: {
            name: 'Performance Report',

            menu: {
                printReport: 'Print Report',
                statstics: 'Previous Record',
                printReportTerm: '개발테스트'
            }
        },
        evaluateMenu: {
            name: 'Evaluation Rules',

            menu: {
                detailEvaluation: 'Evaluation Rules',
            }
        },
        journalRankMenu: {
            name: 'Ranking of Journals',

            menu: {
                journalRank: 'Dept./College’s Journal',
                s2Journal:'JCR/Scopus’s Journal',
            }
        },
        systemsMenu: {
            name: 'System Management',

            menu: {
                notice: 'Notice',
                accessLogs: 'Log Management',
                systemManagement: 'System Management',
                codeManagement: 'Basic Code Management',
                judgementTargets: '심사대상관리',
                judgementResults: '심사결과관리',
                evalManagement: '평가기준관리',
                logManagement: '접속로그관리',
            }
        },
        planMenu: {
            name: 'Achievement Plan',

            menu: {
                plan: 'Achievement Plan',
            }
        },
        userManual: 'TAMS Manual',
    },
    ko: {
		homepage: 'Homepage',
        personalInfo: '신상정보',
        modifyPersonalInfo: '변경',
        researchMenu: {
            name: '연구업적평가',

            menu: {
                article: '논문',
                book: '저역서',
                exhibit: '전시/작품발표',
                academic: '그 외 연구활동',
            }
        },
        educationMenu: {
            name: '교육업적평가',

            menu:{
                teaching: '교육업적',
            }
        },
        volunteerMenu: {
            name : '봉사업적평가',

            menu: {
                service: '봉사업적',
            }
        },
        awardMenu: {
            name: '수상업적평가',

            menu: {
                award: '수상업적'
            }
        },
        reportMenu: {
            name: '보고서출력',

            menu: {
                printReport: '보고서',
                statstics: '통계 및 목록',
                printReportTerm: '개발테스트'
            }
        },
        evaluateMenu: {
            name: '평가시행세칙',

            menu: {
                detailEvaluation: '평가시행세칙',
            }
        },
        journalRankMenu: {
            name: '학술지등급',

            menu: {
                journalRank: '대학(원) 학과선정 학술지',
                s2Journal:'JCR/Scopus 학술지',
            }
        },
        systemsMenu: {
            name: '시스템관리',

            menu: {
                notice: '공지사항',
                accessLogs: '접속로그관리',
                systemManagement: '시스템관리',
                codeManagement: '시스템코드관리',
                judgementTargets: '심사대상관리',
                judgementResults: '심사결과관리',
                evalManagement: '평가기준관리',
                logManagement: '접속로그관리',
            }
        },
        planMenu: {
            name: '업적계획서',

            menu: {
                plan: '업적계획서',
            }
        },
        userManual: 'TAMS 입력 매뉴얼',
    }
}